import { FC, useMemo } from 'react';

import IProduct from 'models/product';
import TagLabel from 'components/TagLabel';
import { scrollWithOffset } from './alerts';
import { IFoodlaCategoryOption } from 'models/category';
import { getRequiredProductFields as sharedRequiredProductFields } from 'generated/productRequirements/base';

export const getRequiredProductFields = (state?: IProduct, rootCategory?: IFoodlaCategoryOption) =>
  sharedRequiredProductFields(state, rootCategory) as { field: keyof IProduct; label: string; missing: boolean }[];

export const getRequireErrorList = (state?: IProduct, rootCategory?: IFoodlaCategoryOption) =>
  getRequiredProductFields(state, rootCategory).filter(({ missing }) => missing).map(({ field, label }) => ({ field, label }));

export const checkRequireError = (state?: IProduct, rootCategory?: IFoodlaCategoryOption) => {
  const errorList = getRequireErrorList(state, rootCategory);
  return !!errorList.length;
};

interface CheckRequireErrorProps {
  state?: IProduct;
  rootCategory?: IFoodlaCategoryOption;
}

const CheckRequireError: FC<CheckRequireErrorProps> = ({ state, rootCategory }) => {
  const errorList = useMemo(() => {
    return getRequireErrorList(state, rootCategory);
  }, [state, rootCategory]);

  return (
    <>
      {errorList.map(({ field, label }) => {
        return (
          <TagLabel focusable key={field} space type="error" onClick={() => scrollWithOffset(field)}>
            <span>{label} är obligatoriskt:</span>
            <span style={{ marginLeft: 4, fontWeight: 400 }}>Klicka här</span>
          </TagLabel>
        );
      })}
    </>
  );
};

export default CheckRequireError;
